module.exports = __webpack_public_path__ + "static/media/example-2.6316515b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/WhyNFPsNeed/example-2.jpg
// module id = 425
// module chunks = 0